import React from 'react';
import { Overlay, Popover, Button } from 'react-bootstrap';
import Calendar from 'react-calendar';
import './custom-calendar.css';

// Separate component for the calendar
const TaskCalendar = ({
  handleDateChange,
  selectedDates,
  start,
  end,
  user,
  gIndex,
  sIndex,
  subtask,
}) => {
  // Function to handle tile content
  const tileContent = ({ date }) => {
    if (
      selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === date.toDateString(),
      )
    ) {
      return <div className="selected-date-dot"></div>;
    }
    return null;
  };

  // Function to handle tile class names
  const tileClassName = ({ date }) => {
    if (
      selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === date.toDateString(),
      )
    ) {
      return 'selected-date';
    }
    return null;
  };

  return (
    <Calendar
      onChange={(dates) =>
        handleDateChange(dates, user, gIndex, sIndex, subtask)
      }
      value={null}
      selectRange={false}
      tileContent={tileContent}
      tileDisabled={false}
      tileClassName={tileClassName}
      minDate={new Date(start)}
      maxDate={new Date(end)}
      className="custom-calendar"
      selectedDates={selectedDates}
      formatShortWeekday={(locale, date) => {
        const weekdays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
        const dayIndex = date.getDay();
        return weekdays[dayIndex];
      }}
    />
  );
};

// Separate component for the action buttons
const ActionButtons = ({
  selectedDates,
  togglePopover,
  sIndex,
  handleSave,
}) => (
  <div className="d-flex justify-content-between mt-3">
    <div className="notice-one-date">
      {selectedDates.length === 0 && (
        <small className="text-danger">Select at least one date</small>
      )}
    </div>
    <div className="button-wrapper-calendar">
      <Button
        size="sm"
        onClick={() => togglePopover(sIndex)}
        className="calendar-cancel-button"
      >
        Cancel
      </Button>
      <Button
        className="calendar-save-button"
        size="sm"
        onClick={handleSave}
        disabled={selectedDates.length === 0}
      >
        Save
      </Button>
    </div>
  </div>
);

// Utility function for date formatting
const formatDateForBackend = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00.000Z`;
};

const CalendarPopover = ({
  showPopover,
  targetRef,
  sIndex,
  gIndex,
  selectedDates,
  togglePopover,
  handleDateChange,
  start,
  end,
  handleSaveSelection,
  subtask,
  user,
}) => {
  const handleSave = () => {
    const updatedFrequency = {
      ...subtask.frequency,
      days: selectedDates.map(formatDateForBackend),
    };

    handleSaveSelection(user, gIndex, sIndex, {
      ...subtask,
      frequency: updatedFrequency,
    });
  };

  return (
    <Overlay
      show={showPopover}
      target={targetRef}
      placement="right"
      containerPadding={20}
    >
      <Popover id={`popover-${sIndex}`} className="calendar-popover">
        <Popover.Body>
          <TaskCalendar
            handleDateChange={handleDateChange}
            selectedDates={selectedDates}
            start={start}
            end={end}
            user={user}
            gIndex={gIndex}
            sIndex={sIndex}
            subtask={subtask}
          />
          <ActionButtons
            selectedDates={selectedDates}
            togglePopover={togglePopover}
            sIndex={sIndex}
            handleSave={handleSave}
          />
        </Popover.Body>
      </Popover>
    </Overlay>
  );
};

export default CalendarPopover;
